// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3Dbzw","tab":"ProcedureTabs_tab__2Rpfo"};